module.exports = __webpack_public_path__ + "static/media/vacuumlabs.32353ac8.png";